// extracted by mini-css-extract-plugin
export default {"container":"SectionMadeiras_container__vf9sb","containerMadeiras":"SectionMadeiras_containerMadeiras__BdQ7l"};